/* eslint-disable prettier/prettier */
const ioRefToKey = {
  76000: 'myPrinters.fwUpdate.settings.body-hp-plus', // ds ignored, hp+, no tank, no ii/paas, no iph
  76002: 'myPrinters.fwUpdate.settings.body-circuitry', // ds, no hp+, no tank, no ii/paas, iph
  76003: 'myPrinters.fwUpdate.settings.body-circuitry-auto', // ds, no hp+, no tank, ii/paas, iph
  76007: 'myPrinters.fwUpdate.settings.body-chip', // ds, no hp+, no tank, no ii/paas, no iph
  76008: 'myPrinters.fwUpdate.settings.body-chip-auto', // ds, no hp+, no tank, ii/paas, no iph
  76012: 'myPrinters.fwUpdate.settings.body-tank', // no ds, no hp+, tank, no ii/paas, no iph
  76017: 'myPrinters.fwUpdate.settings.body-tank-auto-paas', // ds ignored, no hp+, tank, paas, no iph
  76030: 'myPrinters.fwUpdate.settings.body-tank-auto', // no ds, no hp+, tank, ii, no iph
};
export const defaultIoRef = 76007;
export const getIoRefKey = ioRef => ioRefToKey[ioRef] || ioRefToKey[defaultIoRef];

// list extracted from HP internal doc on 2025-11-26
const ds = {
  no: [
    '1GP80A', '27C07AV', '2R3E2A', '2R3E3A', '2R3E5A', '2R3E8A', '2R3F0A', '2R7F3A', '2R7F4A', '2R7F5A',
    '2R7F6A', '2S1H8AV', '2S1H9AV', '2Z599E', '2Z600E', '2Z601E', '2Z605E', '2Z606E', '2Z613A', '2Z614A',
    '2Z615A', '2Z618E', '2Z619E', '2Z620E', '2Z622E', '2Z624E', '2Z632A', '2Z633A', '2Z634A', '381L0A',
    '381U0A', '381U1A', '381U2A', '381U3A', '381U4A', '381U5A', '381V0A', '381V1A', '381V4A', '381V5A',
    '381V6A', '3G628E', '3G630E', '3G635A', '3G636A', '3G650E', '3G652E', '3G657A', '3G658A', '3GX98A',
    '3GX99A', '3GY09A', '3GY10A', '3GY12A', '3GY14A', '3GY15A', '3GY16A', '3GY17A', '3GY18A', '3GY25A',
    '3GY26A', '3PZ16A', '3PZ56A', '4PA39A', '4PA41A', '4PA42A', '4QZ97A', '53P40A', '53P41A', '6GW62E',
    '6GW64A', '6GW99E', '6GX00E', '6GX01E', '6GX04A', '6GX05A', '6GX06A', '7MD66E', '7MD70E', '7MD72E',
    '8X3E6A', '8X3E7A', '8X3E8A', '8X3G4A', '8X3G5A', '8X3G6A', '9YF91E', '9YF97A', '9YF98A', '9YG02E',
    '9YG05E', '9Z0H9A', 'A2W75A', 'A2W76A', 'A3E42A', 'A4CR1AW', 'B43YPA', 'B43YQA', 'B43YRA', 'B43YSA',
    'B5L23A', 'B5L24A', 'B5L25A', 'B5L26A', 'B5L27A', 'B5L38A', 'B5L39A', 'B5L46A', 'B5L47A', 'B5L48A',
    'B5L49A', 'B5L50A', 'B5L54A', 'B6S00A', 'B6S01A', 'B6S02A', 'C5F92A', 'C5F93A', 'C5F94A', 'C5F95A',
    'C5F96A', 'C5F97A', 'C5F98A', 'C5F99A', 'C5J91A', 'C6N21A', 'C6N22A', 'C6N23A', 'CE461A', 'CE651A',
    'CE652A', 'CE653A', 'CE655A', 'CE656A', 'CE657A', 'CE658A', 'CE662A', 'CE710A', 'CE711A', 'CE712A',
    'CF066A', 'CF067A', 'CF068A', 'CF069A', 'CF235A', 'CF236A', 'CF238A', 'CF367A', 'CF455A', 'CF456A',
    'CF484A', 'CF485A', 'CZ172A', 'CZ173A', 'CZ174A', 'CZ175A', 'CZ176A', 'CZ177A', 'CZ178A', 'CZ181A',
    'CZ183A', 'CZ184A', 'CZ185A', 'CZ186A', 'CZ187A', 'CZ244A', 'CZ245A', 'D7P68A', 'D7P71A', 'E6B72A',
    'E6B73A', 'F6J41A', 'F6J42A', 'F6J43A', 'F6J44A', 'F6W13A', 'F6W14A', 'F6W15A', 'F6W16A', 'F6W17A',
    'G2Q48A', 'G3Q34A', 'G3Q35A', 'G3Q36A', 'G3Q37A', 'G3Q39A', 'G3Q46A', 'G3Q47A', 'G3Q50A', 'G3Q57A',
    'G3Q58A', 'G3Q59A', 'G3Q60A', 'G3Q61A', 'G3Q62A', 'G3Q63A', 'G3Q64A', 'G3Q65A', 'G3Q66A', 'G3Q67A',
    'G3Q68A', 'G3Q74A', 'G3Q75A', 'G3Q75AR', 'G3Q76A', 'G3Q77A', 'G3Q78A', 'G3Q79A', 'J8H60A', 'J8H61A',
    'J8J63A', 'J8J64A', 'J8J65A', 'J8J66A', 'J8J70A', 'J8J71A', 'J8J72A', 'J8J73A', 'J8J74A', 'J8J76A',
    'J8J78A', 'J8J79A', 'J8J80A', 'K0Q14A', 'K0Q15A', 'K0Q16A', 'K0Q17A', 'K0Q18A', 'K0Q19A', 'K0Q20A',
    'K0Q21A', 'K0Q22A', 'K9G90A', 'K9G91A', 'L3U51A', 'L3U52A', 'L3U63A', 'L3U64A', 'L3U65A', 'M0P33A',
    'M0P35A', 'M0P36A', 'M0P39A', 'M0P40A', 'W1A23A', 'W1A24A', 'W1A33A', 'W1A34A', 'W1A35A', 'W1A46A',
    'W1A47A', 'W1A57A', 'W1A58A', 'W1A59A', 'W1A60A', 'W2G52A', 'W2G56A', 'W2G57A', 'W3W81A', 'Y5S43A',
    'Y5S47A', 'Y5S50A', 'Y5S53A', 'Y5S54A',
  ],
  yes: [
    '115Q0AW', '1PS54A', '1PS55A', '1PU51A', '1PV64A', '1PV65A', '1PV66A', '1PV67A', '1PV86A', '1PV87A',
    '1PV88A', '1PV89A', '1Y7D2A', '2A130E', '2A130F', '2Z599F', '2Z600F', '2Z601F', '2Z605F', '2Z606F',
    '2Z607F', '2Z609A', '2Z610A', '2Z611A', '2Z618F', '2Z619F', '2Z620F', '2Z622F', '2Z623F', '2Z624F',
    '2Z627A', '2Z628A', '2Z629A', '2Z635A', '2Z636A', '3G628F', '3G629F', '3G630F', '3G631A', '3G632A',
    '3G650F', '3G651F', '3G652F', '3G653A', '3G654A', '3GY03A', '3GY04A', '3GY31A', '3GY32A', '3PZ15A',
    '3PZ35A', '3PZ55A', '3PZ75A', '3PZ95A', '3QA35A', '3QA55A', '3QA75A', '3WT91A', '499M6A', '499M7A',
    '499M8A', '499N4A', '499Q3F', '499Q4F', '499Q5F', '499Q6F', '499Q7F', '499Q8F', '499Q9F', '499R0F',
    '49K84AV', '49K85AV', '49K86A', '49K87A', '49K88A', '49K89AV', '49K90A', '49K91A', '49K92A', '49K93AV',
    '49K94AAE', '49K96AV', '49K97AV', '49K98AV', '49K99AV', '49L00AV', '49L01AV', '49L02A', '49L03AV', '49L04A',
    '49L05AV', '49L06AAE', '4RA80E', '4RA80F', '4RA81F', '4RA82F', '4RA83F', '4RA84F', '4RA85E', '4RA85F',
    '4RA86F', '4RA87F', '4RA88E', '4RA88F', '4RA89A', '4Y279AV', '4Y280AV', '58M42A', '58R10A', '5HH48A',
    '5HH53A', '5HH64E', '5HH64F', '5HH65A', '5HH66A', '5HH67A', '675R6A', '675R8A', '675S0AV', '675S1AV',
    '675S3A', '675S4A', '675S5A', '675S6A', '675S7A', '675S9AV', '675T0AV', '675T1A', '675T2A', '675T3A',
    '675T5AV', '675T6AV', '675T8A', '675T9A', '675U0A', '675U1A', '675U3AV', '675U4AV', '67P98A', '67P99A',
    '67Q02A', '67Q04A', '67Q05A', '67Q06A', '67Q07A', '67Q08A', '6GW62F', '6GW99F', '6GX00F', '6GX01F',
    '6GX09E', '6QN28A', '6QN29A', '6QN30A', '6QN33A', '6QN35A', '6QN36A', '6QN37A', '6QN38A', '6QP97A',
    '6QP98A', '6QP99A', '6QQ00A', '6QQ01A', '6QQ02A', '6QQ03A', '74P25A', '74P26A', '74P27A', '74P28A',
    '74T92F', '759V0F', '759V1F', '759V2F', '76H07A', '76H08A', '76H09A', '76H10A', '76H11A', '7E357A',
    '7F3F2AV', '7H5W6A', '7H5W7A', '7KW48A', '7KW49A', '7KW54A', '7KW55A', '7KW56A', '7KW63A', '7KW64A',
    '7KW72A', '7KW73A', '7KW74A', '7KW75A', '7MD65A', '7MD66F', '7MD67A', '7MD68A', '7MD70F', '7MD71A',
    '7MD72F', '7MD73A', '7MD74A', '7MD75A', '7PS82A', '7PS84A', '7PS85A', '7PS86A', '7PS87A', '7PS94A',
    '7PS95A', '7PS96A', '7PS97A', '7PS98A', '7PS99A', '7PT00A', '7PT01A', '7ZU78A', '7ZU79A', '7ZU81A',
    '7ZU85A', '7ZU86A', '7ZU87A', '7ZU88A', '8D7L0A', '8D7L1A', '8D7L2A', '8J9K4F', '8J9K7F', '8J9K9F',
    '8J9L0F', '8X3D2A', '8X3D4A', '8X3D6A', '8X3D8A', '8X3E0A', '8X3E1A', '8X3E2A', '8X3F0A', '8X3F2A',
    '8X3F4A', '8X3F6A', '8X3F8A', '8X3G0A', '9D2X4F', '9YF82A', '9YF83A', '9YF91F', '9YF94A', '9YF95A',
    '9YG02F', '9YG05F', '9YG08A', '9YG09A', 'A29Z3A', 'A29Z4A', 'A29Z5A', 'A29Z8A', 'A29ZBA', 'A29ZCA',
    'A29ZDA', 'A32R5A', 'B09RYA', 'B09RZA', 'B09S0A', 'B0YW7A', 'B0YW8A', 'B0YW9A', 'B0YX0A', 'B0YX1A',
    'B0YX2A', 'B0YZ1A', 'B0YZ2A', 'B0YZ3A', 'B0ZA1A', 'B0ZA2A', 'B0ZA3A', 'B0ZA4A', 'B0ZA5A', 'B0ZA6A',
    'B0ZA7A', 'BS7S0A', 'J7Z98A', 'J7Z99A', 'J8A04A', 'J8A05A', 'J8A06A', 'J8A10A', 'J8A11A', 'J8A12A',
    'J8A13A', 'J8A17A', 'L3U55A', 'L3U56A', 'L3U66A', 'L3U70A', 'T3U43A', 'T3U44A', 'T3U51A', 'T3U52A',
    'T3U55A', 'T3U56A', 'T3U64A', 'T3U66A', 'T6B51A', 'T6B52A', 'T6B59A', 'T6B60A', 'T6B61A', 'T6B70A',
    'T6B71A', 'T6B74A', 'T6B80A', 'T6B81A', 'T6B82A', 'T6B83A', 'W1A28A', 'W1A29A', 'W1A30A', 'W1A31A',
    'W1A32A', 'W1A51A', 'W1A52A', 'W1A53A', 'W1A56A', 'W1A66A', 'W1A77A', 'W1A78A', 'W1A79A', 'W1A80A',
    'W1Y43A', 'W1Y44A', 'W1Y45A', 'W2G50A', 'W2G51A', 'W2G54A', 'W2G55A', 'Y5S55A',
  ],
};

export const skuIsDs = sku => {
  if (ds.yes.includes(sku)) {
    return true;
  }
  if (ds.no.includes(sku)) {
    return false;
  }
  return undefined;
};
